import PickupsPage from "@features/pickups/pages/pickups-page";
import PickupList from "@features/pickups/components/PickupsList";
import CreatePickup from "@features/pickups/pages/create-pickup";
import PickupManagementPage from "@/features/pickups/pages/PickupManagementPage";
import ImprovedPickupLivreurManagement from "@/features/pickups/components/ImprovedPickupLivreurManagement";
import PickupDashboardPage from "@/features/pickups/pages/PickupDashboardPage";
import ViewPickupPage from "@/features/pickups/pages/ViewPickupPage";
import { AdminManagerOrClientSupportRoute } from "@shared/guards/RoleBasedGuards";

export const pickupsRoutes = {
  path: "/pickups",
  element: <PickupsPage />,
  children: [
    {
      path: "/pickups",
      element: <PickupList />,
    },
    {
      path: "/pickups/create",
      element: <CreatePickup />,
    },
    {
      path: "/pickups/management",
      element: <PickupManagementPage />,
    },
    {
      path: "/pickups/livreur-management",
      element: (
        <AdminManagerOrClientSupportRoute>
          <ImprovedPickupLivreurManagement />
        </AdminManagerOrClientSupportRoute>
      ),
    },
    {
      path: "/pickups/dashboard",
      element: <PickupDashboardPage />,
    },
    {
      path: "/pickups/:id",
      element: <ViewPickupPage />,
    },
  ],
};
